import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-header-page',
    templateUrl: './header-page.component.html',
    styleUrls: ['./header-page.component.scss'],
})
export class HeaderPageComponent implements OnInit {
    @Input() position = 'left';

    positionPreset: { [key: string]: string } = {
        left: 'header-custom',
        center: 'center-header',
    };

    constructor() {
    }

    ngOnInit(): void {
    }

}
